module.exports = __webpack_public_path__ + "img/lote-escuro.97c39434.jpg";